// extracted by mini-css-extract-plugin
module.exports = {"uploadForm":"styles_uploadForm__RQvO_","urlinput":"styles_urlinput__NNaUR","uploadBtn":"styles_uploadBtn__zNHxo"};